const CRISP_WEBSITE_ID = '88cebfcd-480e-4b0e-b6a9-251f6b74be64';
const CRISP_SCRIPT_ID = 'crisp-chat-script';

type CrispCommand = [string, string] | [string, string, unknown];

declare global {
  interface Window {
    $crisp?: CrispCommand[];
    CRISP_WEBSITE_ID?: string;
  }
}

export const ensureCrispLoaded = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  window.$crisp = window.$crisp || [];
  window.CRISP_WEBSITE_ID = CRISP_WEBSITE_ID;

  if (document.getElementById(CRISP_SCRIPT_ID)) return;

  const script = document.createElement('script');
  script.id = CRISP_SCRIPT_ID;
  script.src = 'https://client.crisp.chat/l.js';
  script.async = true;
  document.head.appendChild(script);
};

export const openCrispChat = () => {
  ensureCrispLoaded();
  window.$crisp?.push(['do', 'chat:open']);
};

type CrispIdentity = {
  userId: string;
  email?: string | null;
  name?: string | null;
  avatarUrl?: string | null;
  workspace?: { id: string; name: string; brand_name: string | null; brand_url: string | null; plan: string; state?: string } | null;
};

// Tags the Crisp conversation with who is chatting, so support sees it in the inbox.
export const identifyCrispUser = ({ userId, email, name, avatarUrl, workspace }: CrispIdentity) => {
  // Queue only: Crisp replays these once the script loads, so pages without the chat don't load it.
  const crisp = (window.$crisp = window.$crisp || []);
  if (email) crisp.push(['set', 'user:email', [email]]);
  if (name) crisp.push(['set', 'user:nickname', [name]]);
  if (avatarUrl) crisp.push(['set', 'user:avatar', [avatarUrl]]);
  if (workspace) crisp.push(['set', 'user:company', [workspace.name, workspace.brand_url ? { url: workspace.brand_url } : {}]]);
  crisp.push(['set', 'session:data', [[
    ['user_id', userId],
    ['workspace_id', workspace?.id ?? ''],
    ['workspace_name', workspace?.name ?? ''],
    ['brand_name', workspace?.brand_name ?? ''],
    ['brand_url', workspace?.brand_url ?? ''],
    ['plan', workspace?.plan ?? ''],
    ['workspace_state', workspace?.state ?? ''],
  ]]]);
};

// Drops the previous user's conversation so the next person on this browser starts fresh.
export const resetCrispSession = () => {
  window.$crisp?.push(['do', 'session:reset']);
};
